const CREDIT_ENTITY = {
  CETELEM: 1
};

export { CREDIT_ENTITY };
